
namespace RioERP.Carts {
    export class FranchiseeProductCategoryColumns {
        static columnsKey = 'Carts.FranchiseeProductCategory';
    }
}